module.exports = __webpack_public_path__ + "img/terbaca_inbox.a0c0f03c.svg";